import { useEffect, useMemo, useState } from "react"
import { useTranslation } from "react-i18next";
import { AppTester } from "supporting";
import { COMPETITIONS_CONTEXTS } from "../const/competitionContexts";
import { getPathContext } from "core/helpers/getPathContext";
import { slashPathIndex } from "shared/constants/enginePaths";

const removeMediiia = (str: string) => {
    return str.replace(/mediiia/gi, '');
}

export const useShowcaseTexts = (currentTab?: string) => {
    const { t, i18n: { language } } = useTranslation();
    const isHse = AppTester.isHSEDesign() || AppTester.isSchool();
    const isAcademy = AppTester.isAcademy();
    const isDeziiign = AppTester.isCompetition() && !AppTester.isMediiia();
    const isDafes = AppTester.isGeoDafes();
    const isCGRave = AppTester.isCGRAVE();
    const isAdcrDafesNet = AppTester.isAdcrDafesNet();
    const isGreenAward = AppTester.isGreenAward();
    const isMediiia = AppTester.isMediiia();
    const isHistoryMediiia = AppTester.isHistoryMediiia();
    const isGeograffee = AppTester.isGeograffee();
    const isPortfolio365 = AppTester.isPortfolio365();
    const isKiiidsArt = AppTester.isKiiidsArt()
    const isLmsMediiia = AppTester.isLectureMediiia();
    const isCompetition = AppTester.isCompetition();
    const isSportMediiia = AppTester.isMediiiaSport();
    const isUrbanAwards = AppTester.isMediiiaUrban()
    const isHseCreative = AppTester.isCreativeHSE()
    const isGameDeziiign = AppTester.isGameDeziiign();
    const isFashionDeziiign = AppTester.isFashionDeziiign();
    const isBrnd = AppTester.isBrnd();
    const isBooksGallllery = AppTester.isBooksGallllery();
    const isLabDeziiign = AppTester.isLabDeziiign();

    const {application, mode: env} = getPathContext();

    const { has: isMediaContext, name: mediaContextName } = useMemo(() => {
        const has = !!Object.values(slashPathIndex['deziiign/mediiia'])?.find((i) => i === application);
        const splittedCtx = Object.values(slashPathIndex['deziiign/mediiia'])?.find((i) => i === application)?.split('/')?.[1];
        let name = ''
        if (!!splittedCtx) {
            name = removeMediiia(splittedCtx);
        }
        return { has, name }
    }, [application]);

    const titlePrefix = 'hse_showcases_title.competitions.title.';
    const descPrefix = 'hse_showcases_title.competitions.description.';

    const [data, setData] = useState({
        title: '',
        description: '',
    })

    const setTranslatedData = (postFix?: string, descriptionPostfix?: string) => {
        let title = t(`${titlePrefix}${postFix}`);
        let description = t(`${descPrefix}${descriptionPostfix || postFix}`);

        setData({ title, description })
    }

    const setMediiiaData = ({ title, description }: { title: string, description: string}) => {
        setData({ title, description })
    }


    useEffect(() => {
        if (isHistoryMediiia) {
            return setTranslatedData('history_mediiia_title')
        }
        if (isLmsMediiia) {
            return setTranslatedData('lecture_title')
        }
        else if (isMediiia && !isMediaContext) {
            return setTranslatedData('mediiia_title')
        } else if (isMediaContext && !isUrbanAwards) {
            let title = '';
            let description = t(`${descPrefix}${'mediiia_title'}`);

            if (mediaContextName === 'stories') {
                title = 'TELLING STORIES AWARDS';
                description = t(`${descPrefix}${'stories'}`);
            } else if (mediaContextName === 'event') {
                title = 'PORTFOLIO 365 AWARDS';
            } else if (mediaContextName === 'prof') {
                title = 'PROFI AWARDS';
            } else if (mediaContextName === 'music') {
                title = 'SOUND AWARDS';
            } else if (mediaContextName === 'nature') {
                title = 'ASTRO AWARDS';
            }else {
                title = mediaContextName.toUpperCase() + ' AWARDS';
                description = t(`${descPrefix}${'mediiia_title'}`); 
            }

            setMediiiaData({ title, description })
        } else if (isGameDeziiign) {
            setTranslatedData('game_deziiign_title')
        } else if (isFashionDeziiign) {
            setTranslatedData('fashion_deziiign_title')
        } else if (isUrbanAwards) {
            setTranslatedData('urban_deziiign_title')
        }
        else if (isDeziiign) {
            setTranslatedData(currentTab === COMPETITIONS_CONTEXTS.briefs ? 'deziiign_factory_title' : 'deziiign_title')
        } else if (isHse) {
            setTranslatedData('hse_title')
        } else if (isBrnd) {
            setTranslatedData('brnd_title') 
        } else if (isBooksGallllery) {
            setTranslatedData('books_gallllery_title') 
        } else if (isAcademy) {
            setTranslatedData(`creative_title_${currentTab}`) 
        } else if (isDafes) {
            setTranslatedData('dafes_title') 
        } else if (isAdcrDafesNet) {
            setTranslatedData('adcr_title') 
        } else if (isGreenAward) {
            setTranslatedData(currentTab === COMPETITIONS_CONTEXTS.greenaward ? 'greenaward_awards_title_greenaward' : 'greenaward_awards_title_lastgreenaward') 
        } else if (isPortfolio365) {
            setTranslatedData('awards_title') 
        } else if (isKiiidsArt) {
            setTranslatedData('kiiids_awards_title') 
        } else if (isCGRave) {
            setTranslatedData('cgrave_title') 
        } else if (isLabDeziiign) {
            setTranslatedData('lab_title', 'deziiign_title') 
        } else {
            setTranslatedData('deziiign_title') 
        }

    } , [currentTab, language, mediaContextName])

    return {...data}
}import { useEffect, useMemo, useState } from "react"
import { useTranslation } from "react-i18next";
import { AppTester } from "supporting";
import { COMPETITIONS_CONTEXTS } from "../const/competitionContexts";
import { getPathContext } from "core/helpers/getPathContext";
import { slashPathIndex } from "shared/constants/enginePaths";

const removeMediiia = (str: string) => {
    return str.replace(/mediiia/gi, '');
}

export const useShowcaseTexts = (currentTab?: string) => {
    const { t, i18n: { language } } = useTranslation();
    const isHse = AppTester.isHSEDesign() || AppTester.isSchool();
    const isAcademy = AppTester.isAcademy();
    const isDeziiign = AppTester.isCompetition() && !AppTester.isMediiia();
    const isDafes = AppTester.isGeoDafes();
    const isCGRave = AppTester.isCGRAVE();
    const isAdcrDafesNet = AppTester.isAdcrDafesNet();
    const isGreenAward = AppTester.isGreenAward();
    const isMediiia = AppTester.isMediiia();
    const isHistoryMediiia = AppTester.isHistoryMediiia();
    const isGeograffee = AppTester.isGeograffee();
    const isPortfolio365 = AppTester.isPortfolio365();
    const isKiiidsArt = AppTester.isKiiidsArt()
    const isLmsMediiia = AppTester.isLectureMediiia();
    const isCompetition = AppTester.isCompetition();
    const isSportMediiia = AppTester.isMediiiaSport();
    const isUrbanAwards = AppTester.isMediiiaUrban()
    const isHseCreative = AppTester.isCreativeHSE()
    const isGameDeziiign = AppTester.isGameDeziiign();
    const isFashionDeziiign = AppTester.isFashionDeziiign();
    const isBrnd = AppTester.isBrnd();
    const isBooksGallllery = AppTester.isBooksGallllery();
    const isLabDeziiign = AppTester.isLabDeziiign();

    const {application, mode: env} = getPathContext();

    const { has: isMediaContext, name: mediaContextName } = useMemo(() => {
        const has = !!Object.values(slashPathIndex['deziiign/mediiia'])?.find((i) => i === application);
        const splittedCtx = Object.values(slashPathIndex['deziiign/mediiia'])?.find((i) => i === application)?.split('/')?.[1];
        let name = ''
        if (!!splittedCtx) {
            name = removeMediiia(splittedCtx);
        }
        return { has, name }
    }, [application]);

    const titlePrefix = 'hse_showcases_title.competitions.title.';
    const descPrefix = 'hse_showcases_title.competitions.description.';

    const [data, setData] = useState({
        title: '',
        description: '',
    })

    const setTranslatedData = (postFix?: string, descriptionPostfix?: string) => {
        let title = t(`${titlePrefix}${postFix}`);
        let description = t(`${descPrefix}${descriptionPostfix || postFix}`);

        setData({ title, description })
    }

    const setMediiiaData = ({ title, description }: { title: string, description: string}) => {
        setData({ title, description })
    }


    useEffect(() => {
        if (isHistoryMediiia) {
            return setTranslatedData('history_mediiia_title')
        }
        if (isLmsMediiia) {
            return setTranslatedData('lecture_title')
        }
        else if (isMediiia && !isMediaContext) {
            return setTranslatedData('mediiia_title')
        } else if (isMediaContext && !isUrbanAwards) {
            let title = '';
            let description = t(`${descPrefix}${'mediiia_title'}`);

            if (mediaContextName === 'stories') {
                title = 'TELLING STORIES AWARDS';
                description = t(`${descPrefix}${'stories'}`);
            } else if (mediaContextName === 'event') {
                title = 'PORTFOLIO 365 AWARDS';
            } else if (mediaContextName === 'prof') {
                title = 'PROFI AWARDS';
            } else if (mediaContextName === 'music') {
                title = 'SOUND AWARDS';
            } else if (mediaContextName === 'nature') {
                title = 'ASTRO AWARDS';
            }else {
                title = mediaContextName.toUpperCase() + ' AWARDS';
                description = t(`${descPrefix}${'mediiia_title'}`); 
            }

            setMediiiaData({ title, description })
        } else if (isGameDeziiign) {
            setTranslatedData('game_deziiign_title')
        } else if (isFashionDeziiign) {
            setTranslatedData('fashion_deziiign_title')
        } else if (isUrbanAwards) {
            setTranslatedData('urban_deziiign_title')
        }
        else if (isDeziiign) {
            setTranslatedData(currentTab === COMPETITIONS_CONTEXTS.briefs ? 'deziiign_factory_title' : 'deziiign_title')
        } else if (isHse) {
            setTranslatedData('hse_title')
        } else if (isBrnd) {
            setTranslatedData('brnd_title') 
        } else if (isBooksGallllery) {
            setTranslatedData('books_gallllery_title') 
        } else if (isAcademy) {
            setTranslatedData(`creative_title_${currentTab}`) 
        } else if (isDafes) {
            setTranslatedData('dafes_title') 
        } else if (isAdcrDafesNet) {
            setTranslatedData('adcr_title') 
        } else if (isGreenAward) {
            setTranslatedData(currentTab === COMPETITIONS_CONTEXTS.greenaward ? 'greenaward_awards_title_greenaward' : 'greenaward_awards_title_lastgreenaward') 
        } else if (isPortfolio365) {
            setTranslatedData('awards_title') 
        } else if (isKiiidsArt) {
            setTranslatedData('kiiids_awards_title') 
        } else if (isCGRave) {
            setTranslatedData('cgrave_title') 
        } else if (isLabDeziiign) {
            setTranslatedData('lab_title', 'deziiign_title') 
        } else {
            setTranslatedData('deziiign_title') 
        }

    } , [currentTab, language, mediaContextName])

    return {...data}
}